import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Typography } from "@circleco/compass/components/Typography";
import type { ReactNode } from "react";

import { MessageActions } from "./MessageActions";

interface UserMessageBubbleProps {
  actions?: ReactNode;
  align?: "start" | "end";
  children: ReactNode;
}

// `peer/bubble` is what reveals the actions row on hover.
export const UserMessageBubble = ({
  actions,
  align = "end",
  children,
}: UserMessageBubbleProps) => (
  <div className="flex w-fit max-w-[80%] flex-col">
    <div
      className={classNames("peer/bubble pb-2", {
        "self-start": align === "start",
        "self-end": align === "end",
      })}
    >
      <div className="bg-secondary rounded-lg px-4 py-2.5 [overflow-wrap:anywhere]">
        <Typography variant="body-sm" color="primary" component="div">
          {children}
        </Typography>
      </div>
    </div>
    <MessageActions actionsAlignment={align}>{actions}</MessageActions>
  </div>
);
